import React from 'react';
import styled from 'styled-components';
import SubLayout from '../components/layout/SubLayout';
import { aboutMenus } from '../data/aboutMenus';

const YearSection = styled.section`
  margin-bottom: 50px;
`;

const YearTitle = styled.h4`
  font-size: 2rem;
  color: #004080;
  font-weight: 800;
  margin: 0 0 15px 0;
  border-bottom: 2px solid #ddd;
  padding-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }
`;

const HistoryList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const HistoryItem = styled.li`
  display: flex;
  padding: 10px 0;
  font-size: 1rem;
  color: #555;
  border-bottom: 1px dashed #eee;

  .date {
    width: 50px;
    font-weight: 700;
    color: #888;
    flex-shrink: 0;
  }

  .event {
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 3px;

    .date {
      width: auto;
      font-size: 0.85rem;
    }
  }
`;

const historyData = [
  {
    year: "2025",
    items: [
      { date: "9월", event: "안전보건경영시스템(ISO45001) 취득" }
    ]
  },
  {
    year: "2022",
    items: [
      { date: "7월", event: "지붕판금·건축물조립공사업, 습식·방수공사업, 포장공사업 면허 취득" }
    ]
  },
  {
    year: "2020",
    items: [
      { date: "4월", event: "조경식재공사업 면허 취득" }
    ]
  },
  {
    year: "2018",
    items: [
      { date: "2월", event: "한국철도공사 강원본부 KTX 및 경강선 환경미화관리" },
      { date: "2월", event: "환경경영시스템(ISO-14001) 취득" },
      { date: "7월", event: "실내건축공사업 면허 취득" }
    ]
  },
  {
    year: "2017",
    items: [
      { date: "2월", event: "국방부 계룡대 환경미화관리" },
      { date: "4월", event: "인천국제공항 T2 여객터미널 환경미화관리" },
      { date: "8월", event: "기술혁신형 중소기업(Inno-Biz) 취득" }
    ]
  },
  {
    year: "2016",
    items: [
      { date: "5월", event: "안전보건경영시스템(OHSAS 18001) 취득" },
      { date: "6월", event: "한국철도공사 강원본부 철도역사 환경미화관리" }
    ]
  },
  {
    year: "2015",
    items: [
      { date: "5월", event: "시설물유지관리업 면허 취득" },
      { date: "7월", event: "경기도 일자리 우수기업 선정" },
      { date: "9월", event: "경복대학교 산학협력 MOU" },
      { date: "11월", event: "품질경영시스템(ISO-9001) 취득" }
    ]
  },
  {
    year: "2014",
    items: [
      { date: "11월", event: "한국서비스품질 우수기업 인증" }
    ]
  },
  {
    year: "2013",
    items: [
      { date: "1월", event: "의정부시 자활센터 MOU" },
      { date: "5월", event: "의정부시 검찰청 MOU" },
      { date: "12월", event: "국회의사당 환경미화관리" }
    ]
  },
  {
    year: "2012",
    items: [
      { date: "1월", event: "자원봉사단체 등록" },
      { date: "2월", event: "의정부시, 신한대학교, 양주출입국관리소, 중부지방고용노동청 MOU" },
      { date: "12월", event: "경영혁신 중소기업 인증 MAIN-BIZ" }
    ]
  },
  {
    year: "2011",
    items: [
      { date: "4월", event: "통신판매업 개시" },
      { date: "4월", event: "저수조청소/보수 개시" },
      { date: "11월", event: "예비사회적기업 지정" },
      { date: "11월", event: "국제빌딩경영관리사협회 지부장" },
      { date: "12월", event: "의정부시 최초 사회적기업 인증" },
      { date: "12월", event: "여성기업확인" }
    ]
  },
  {
    year: "2008",
    items: [
      { date: "4월", event: "회사설립" },
      { date: "6월", event: "소독업 개시" },
      { date: "12월", event: "위생관리업 개시" }
    ]
  }
];

const History = () => {
  return (
    <SubLayout title="연혁" sidebarMenus={aboutMenus} bannerBg="/images/bg_building.jpg">
      {historyData.map((section, index) => (
        <YearSection key={index}>
          <YearTitle>{section.year}</YearTitle>
          <HistoryList>
            {section.items.map((item, i) => (
              <HistoryItem key={i}>
                <span className="date">{item.date}</span>
                <span className="event">{item.event}</span>
              </HistoryItem>
            ))}
          </HistoryList>
        </YearSection>
      ))}
    </SubLayout>
  );
};

export default History;
